import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import CosmosHero from "./CosmosHero";
import WhyCosmosSDK from "./WhyCosmosSDK";
import CustomBlockchain from "./CustomBlockchain";
import Scalability from "./Scalability";

function Cosmos() {
  return (
    <>
      <Header />
      <CosmosHero />
      <WhyCosmosSDK />
      <CustomBlockchain />
      <Scalability />
      <Footer />
    </>
  );
}

export default Cosmos;
